module.exports = "/images/Create your submittal log - 3.jpg";